import React from 'react'
import { useHistory } from 'react-router'
import { Profile2User, ProfileCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import { Routes } from '@SonarCX/Routes'
import { ReminderItemProps } from '..'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from '../styles'

const ReminderUser: React.FC<ReminderItemProps> = ({ object_id }) => {
  const theme = useTheme()
  const classes = useStyles()
  const history = useHistory()
  const { allUsers, loadUser } = useUserAPI()

  const user = React.useMemo(
    () => allUsers[object_id] ?? null,
    [allUsers, object_id]
  )

  const navigate = () => {
    history.push(
      `${user?.type?.external ? Routes.CUSTOMERS : Routes.USERS}/${object_id}`
    )
  }
  // Load concerning user if needed
  React.useEffect(() => {
    if (!user) {
      loadUser(object_id)
    }
  }, [user, loadUser, object_id])

  if (!user) return null

  const icon = user.type.external ? (
    <ProfileCircle
      size={theme.size.base}
      variant='Bulk'
      color={theme.palette.primary.main}
    />
  ) : (
    <Profile2User
      size={theme.size.base}
      variant='Bulk'
      color={theme.palette.primary.main}
    />
  )

  return (
    <div className={classes.root} onClick={navigate}>
      <span className={classes.info}>
        <Tooltip title={user.type.external ? 'Contact' : 'Team'}>
          {icon}
        </Tooltip>
        <span className={classes.title}> {user.name} </span>
      </span>
    </div>
  )
}

export default ReminderUser
